import {useFormContext} from 'react-hook-form'
import {ShellPartialFormSchema, ShellUpgradeFormSchema} from '../formSchemas'
import {z} from 'zod'

export const useExperienceShellFormContext = (isUpgrade: boolean) => {
    const schema = isUpgrade ? ShellUpgradeFormSchema : ShellPartialFormSchema
    return useFormContext<z.infer<typeof schema>>()
}
